import { render, staticRenderFns } from "./ServiceProviderConfiguration.vue?vue&type=template&id=5d5146bc&scoped=true"
import script from "./ServiceProviderConfiguration.vue?vue&type=script&lang=js"
export * from "./ServiceProviderConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderConfiguration.vue?vue&type=style&index=0&id=5d5146bc&prod&lang=scss&scoped=true"
import style1 from "./ServiceProviderConfiguration.vue?vue&type=style&index=1&id=5d5146bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5146bc",
  null
  
)

export default component.exports